import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { ReservationExaminationStatus } from '../../../../_shared/enums/examination/reservation-examination-status.enum';
import { ReservationExaminationResponseDto } from '../../../../_shared/model/examinations/examination-response-dto';

@Component({
    selector: 'app-examinations-status-list',
    templateUrl: './examinations-status-list.component.html',
    styleUrls: ['./examinations-status-list.component.scss'],
})
export class ExaminationsStatusListComponent {
    public reservationExaminationStatus = ReservationExaminationStatus;
    @Input() mini = false;
    @Input() examinationsProgressView: Observable<number>;
    @Input() examinationsForReservationView: Observable<ReservationExaminationResponseDto[]>;
}
